<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="120px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.productLine')">
                  <el-select
                    v-model="formselect.productLine"
                    filterable
                    @change="resetCenter"
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option label="PAC" value="PAC"></el-option>
                    <el-option :label="$t('desc.other')" value="Other"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('title.customerCenter')">
                  <el-select
                    v-model="formselect.customerCenterRegionId"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in center"
                      :value="item.id"
                      :label="item.center"
                      :key="'inx2' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

              <el-col :md="6" :sm="12" :xs="24" style="margin-top: 10px">
                <el-button type="primary" @click="getData" size="small">{{
                  $t("button.query")
                }}</el-button>
                <el-button @click="reset" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>

          <div class="KPIDiv">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="16" :md="16" :lg="16">
                <div class="block homeCon">
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <div
                        class="LeftB"
                        style="border-left-color: #007393;cursor:pointer;"
                        @click="toDeviceRegi('1', '99', 'false')"
                      >
                        <h4>{{ $t("desc.shipped_penddingConnect") }}</h4>
                        <span>
                          {{ KPIData.unConnectCount }}
                          <small>{{ $t("desc.tai") }}</small>
                        </span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <div
                        class="LeftB"
                        style="border-left-color: #e54c41;cursor:pointer;"
                        @click="toDeviceBind('1', 'true')"
                      >
                        <h4>{{ $t("desc.NotAbletoConnect") }}</h4>
                        <span>
                          {{ KPIData.unBindCount }}
                          <small>{{ $t("desc.tai") }}</small>
                        </span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <div class="LeftB" style="border-left-color: #e54c41">
                        <h4>{{ $t("desc.OfflineNormal") }}</h4>
                        <span
                          >{{ KPIData.offLineInitiativeCount }}
                          <small>{{ $t("desc.tai") }}</small>
                        </span>
                      </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <div class="LeftB" style="border-left-color: #e54c41">
                        <h4>{{ $t("desc.OfflineFault") }}</h4>
                        <span
                          >{{ KPIData.offLineTripCount }}
                          <small>{{ $t("desc.tai") }}</small>
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="divide"></div>
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <a
                        class="LeftB"
                        style="border-left-color: #007393"
                        :href="insight4_url"
                        target="_blank"
                      >
                        <h4>{{ $t("desc.Insight4") }}</h4>
                        <span>{{ insight4_count }} </span>
                      </a>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <a
                        class="LeftB"
                        style="border-left-color: #007393"
                        :href="insight3_url"
                        target="_blank"
                      >
                        <h4>{{ $t("desc.Insight3") }}</h4>
                        <span> {{ insight3_count }} </span>
                      </a>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <a
                        class="LeftB"
                        style="border-left-color: #007393"
                        :href="insight3_url"
                        target="_blank"
                      >
                        <h4>{{ $t("desc.Insight3") }}</h4>
                        <span> {{ insight3_count }} </span>
                      </a>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <a
                        class="LeftB"
                        style="border-left-color: #007393"
                        :href="insight5_url"
                        target="_blank"
                      >
                        <h4>{{ $t("desc.Insight5") }}</h4>
                        <span> {{ insight5_count }} </span>
                      </a>
                    </el-col>
                  </el-row>
                  <!-- <div class="divide"></div>
                  <el-row :gutter="24">
                    <el-col :xs="12" :sm="12" :md="6" :lg="6">
                      <div class="LeftB" style="border-left-color: #fff">
                        <h4>{{ $t("desc.Warranty") }}</h4>
                        <span></span>
                      </div>
                    </el-col>
                  </el-row> -->
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <div class="block homeCon">
                      <el-row :gutter="24">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                          <div
                            class="LeftB"
                            @click="toMaintain('1')"
                            style="border-left-color: #ffb951;cursor:pointer;"
                          >
                            <h4>{{ $t("desc.MachinesDueService") }}</h4>
                            <span
                              >{{ KPIData.waitServiceCount }}
                              <small>{{ $t("desc.tai") }}</small>
                            </span>
                          </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                          <div class="LeftB" style="border-left-color: #81818b">
                            <h4>{{ $t("desc.MachinePastDueService") }}</h4>
                            <span
                              >{{ KPIData.expireServiceCount }}
                              <small>{{ $t("desc.tai") }}</small>
                            </span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <div class="block homeCon">
                      <el-row :gutter="24">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                          <div
                            class="LeftB"
                            @click="toAlarm('onWarning')"
                            style="border-left-color: #e64b41;cursor:pointer;"
                          >
                            <h4>{{ $t("desc.WarningNumber") }}</h4>
                            <span
                              >{{ KPIData.warningCount }}
                              <small>{{ $t("desc.tai") }}</small>
                            </span>
                          </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                          <div
                            class="LeftB"
                            @click="toAlarm('onTrip')"
                            style="border-left-color: #bf2308;cursor:pointer;"
                          >
                            <h4>{{ $t("desc.TripNumber") }}</h4>
                            <span
                              >{{ KPIData.tripCount }}
                              <small>{{ $t("desc.tai") }}</small>
                            </span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div
                        class="LeftB"
                        @click="toUseRate()"
                        style="border-left-color: #fff;cursor:pointer;"
                      >
                        <h4>{{ $t("desc.UtilizationRate") }}</h4>
                        <span
                          >{{ KPIData.useRate }}
                          <small>%</small>
                        </span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <div class="block homeCon">
                      <div class="LeftB" style="border-left-color: #fff">
                        <h4>{{ $t("desc.IoTGSMCosts") }}</h4>
                        <span
                          >{{ KPIData.lastMonthSimAmount }}
                          <small>{{ $t("desc.yuan") }}</small>
                        </span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <!-- <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(1)"
                >
                  <h4>{{ $t("desc.SendOutCount") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.sendOutCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
               <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(2)"
                >
                  <h4>{{ $t("desc.wait_bind") }}</h4>
                  <span style="color: #ffb20a"
                    >{{ KPIData.waitBindCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(3)"
                >
                  <h4>{{ $t("desc.already_bind") }}</h4>
                  <span style="color: #ffb20a"
                    >{{ KPIData.bindCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(4)"
                >
                  <h4>{{ $t("desc.Connected_Offline") }}</h4>
                  <span style="color: #ff4040"
                    >{{ KPIData.offLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(5)"
                >
                  <h4>{{ $t("desc.Connected_Active") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.onLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(6)"
                >
                  <h4>{{ $t("desc.RetroFit") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.localInstallCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(7)"
                >
                  <h4>{{ $t("desc.FactoryFit") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.factoryInstallCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(8)"
                >
                  <h4>{{ $t("desc.RetroFitBind") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.localInstallBindCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(9)"
                >
                  <h4>{{ $t("desc.FactoryFitBind") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.factoryInstallBindCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(10)"
                >
                  <h4>{{ $t("desc.FactoryFitWaitBind") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.factoryInstallWaitBindCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(11)"
                >
                  <h4>{{ $t("desc.RetroFitOffLine") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.localInstallOffLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(12)"
                >
                  <h4>{{ $t("desc.FactoryFitOffline") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.factoryInstallOffLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(13)"
                >
                  <h4>{{ $t("desc.RetroFitOnLine") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.localInstallOnLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col>
              <el-col :lg="4" :md="6" :sm="8" :xs="24">
                <div
                  class="block homeCon onclickbtn"
                  :style="BlockH"
                  @click="toDeviceDetail(14)"
                >
                  <h4>{{ $t("desc.FactoryFitOnline") }}</h4>
                  <span style="color: #08930f"
                    >{{ KPIData.factoryInstallOnLineCount
                    }}<small>{{ $t("desc.tai") }}</small></span
                  >
                </div>
              </el-col> -->

              <!-- <el-col :lg="4" :md="6" :sm="8" :xs="24">
                  <div class="block" :style="BlockH">
                    <h4>{{$t("desc.ActiveCriticalAlarmsTrips")}}</h4>
                    <span>8<small>{{$t("desc.tai")}}</small></span>
                  </div>
                </el-col> -->
            </el-row>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { GetKPIStat, getCustomerRegionTable } from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {
      formselect: {
        customerRegionId: "",
        customerCenterRegionId: "",
        productLine:"Other"
      },
      KPIData: {},
      BlockH: {
        height: "",
        minHeight: "70px",
        // maxHeight:'100px',
      },
      allRegion: [],
      region: [],
      center: [],
      insight3_url: "",
      insight4_url: "",
      insight5_url: "",
      insight3_count: 0,
      insight4_count: 0,
      insight5_count: 0,
    };
  },

  mounted() {
    this.insight4_url = Globals.Insight4_Url;
    this.insight3_url = Globals.Insight3_Url;
    this.insight5_url = Globals.Insight5_Url;
    this.insight4_count = Globals.Insight4_Count;
    this.insight3_count = Globals.Insight3_Count;
    this.insight5_count = Globals.Insight5_Count;
    this.getData();
    this.getRegion();
  },
  methods: {
    //获取地区
    getRegion() {
      var that = this;
      getCustomerRegionTable()
        .then((res) => {
          if (res.success) {
            var regionList = JSON.parse(JSON.stringify(res.result.centerList));
            var centerList = JSON.parse(JSON.stringify(res.result.centerList));
            that.allRegion = regionList;
            that.center = centerList;
            that.region = this.reduce(regionList);
          } else {
            this.$message.error(res.error.message);
          }
        })
        .catch((err) => {
          this.$message.error(err.error.message);
        });
    },
    changeRegion() {
      var that = this;
      var allRegionList = that.allRegion;
      var newCenter = [];
      if (
        that.formselect.customerRegionId != "" &&
        that.formselect.customerRegionId != null &&
        that.formselect.customerRegionId != "all"
      ) {
        allRegionList.forEach((o) => {
          if (o.parentId == that.formselect.customerRegionId) newCenter.push(o);
        });
        that.center = newCenter;
      } else {
        that.center = that.allRegion;
      }
    },
    getData() {
      let that = this;
      if (this.formselect.customerRegionId == "all") {
        this.formselect.customerRegionId = "";
      }
      if (this.formselect.customerCenterRegionId == "all") {
        this.formselect.customerCenterRegionId = "";
      }
      GetKPIStat(
        that.formselect.customerRegionId,
        that.formselect.customerCenterRegionId,
        that.formselect.productLine
      ).then((res) => {
        let data = res.result;
        this.KPIData = data;
      });
    },
    resetCenter() {
      this.$set(this.formselect, "customerCenterRegionId", "");
    },
    //数组对象去重
    reduce(config) {
      var hash = {};
      const newArr = config.reduceRight((item, next) => {
        hash[next.area] ? "" : (hash[next.area] = true && item.push(next));
        return item;
      }, []);
      return newArr;
    },
    reset() {
      this.formselect = {
        customerRegionId: "",
        customerCenterRegionId: "",
        productLine:"Other"
      };
      this.getData();
    },
    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    onSubmit() {},
    SetHeight() {
      var mHeight = window.innerHeight - 300; //总高
      this.BlockH.height = mHeight / 3 - 10 + "px";
    },

    toUseRate() {
      this.$router.push({
        name: "/report/utilizationStatistics",
      });
    },
    toMaintain(state) {
      this.$router.push({
        name: "/maintain/index",
        params: {
          gatewayState: state,
        },
      });
    },
    toAlarm(e) {
      this.$router.push({
        name: "/Alarm/AlarmList",
        params: {
          customerRegion: this.customerRegion,
          alarmStatus: "1",
          alarmType: e || "",
          isContainWJ: "false",
        },
      });
    },
    toDeviceRegi(gatewayState, gsnState, isContainWJ) {
      this.$router.push({
        name: "/device/register",
        params: {
          gatewayState: gatewayState,
          gsnState: gsnState,
          isContainWJ: isContainWJ,
        },
      });
    },
    toDeviceBind(gatewayState, isContainWJ) {
      this.$router.push({
        name: "/device/register",
        params: {
          gatewayState: gatewayState,
          isContainWJ: isContainWJ,
        },
      });
    },

    toDeviceDetail(type) {
      this.$router.push({
        path: "/report/deviceDetail",
        query: {
          bigRegionId: this.formselect.customerRegionId,
          customerCenterId: this.formselect.customerCenterRegionId,
          productLine: this.formselect.productLine,
          type: type,
        },
      });
    },

    toDeviceInstall(gatewayState, installMethod, gsnState) {
      this.$router.push({
        name: "/device/register",
        params: {
          installMethod: installMethod,
          gatewayState: gatewayState,
          gsnState: gsnState,
        },
      });
    },
  },
  created() {
    window.addEventListener("resize", this.SetHeight);
    var _self = this;
    this.$nextTick(() => {
      _self.SetHeight();
    });
  },
};
</script>


